// extracted by mini-css-extract-plugin
export default {"back":"BackButton_back__CihsB","link":"BackButton_link__ufvgv"};